import { useState } from "react";
import { Panel, Label } from "@/components/SplitLayout";
import CopyButton from "@/components/CopyButton";
import { ArrowsLeftRight } from "@phosphor-icons/react";

const encode = (s) => btoa(unescape(encodeURIComponent(s)));
const decode = (s) => decodeURIComponent(escape(atob(s)));

export default function Base64Tool() {
  const [mode, setMode] = useState("encode");
  const [input, setInput] = useState("");

  let output = "";
  let error = "";
  if (input) {
    try {
      output = mode === "encode" ? encode(input) : decode(input);
    } catch (e) {
      error = "Invalid Base64 input — cannot decode.";
    }
  }

  return (
    <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
      <div className="space-y-4">
        <div className="space-y-2">
          <Label>Mode</Label>
          <div className="flex gap-2">
            {[
              { id: "encode", label: "Encode" },
              { id: "decode", label: "Decode" },
            ].map((o) => (
              <button
                key={o.id}
                data-testid={`base64-mode-${o.id}`}
                onClick={() => setMode(o.id)}
                className={`flex-1 border px-4 py-2.5 text-xs font-bold uppercase tracking-[0.1em] transition-all duration-150 ${
                  mode === o.id
                    ? "border-primary bg-primary text-primary-foreground"
                    : "border-border bg-card hover:border-primary hover:text-primary"
                }`}
              >
                {o.label}
              </button>
            ))}
          </div>
        </div>
        <div className="space-y-2">
          <Label>{mode === "encode" ? "Plain text" : "Base64 string"}</Label>
          <textarea
            data-testid="base64-input"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder={mode === "encode" ? "Type text to encode…" : "Paste Base64 to decode…"}
            className="h-[300px] w-full resize-none border border-border bg-card p-5 font-mono text-sm outline-none focus:ring-2 focus:ring-primary"
          />
        </div>
        <div className="flex items-center gap-2 text-xs text-muted-foreground">
          <ArrowsLeftRight size={16} weight="bold" className="text-primary" />
          Switch modes to reverse the operation.
        </div>
      </div>

      <div className="lg:sticky lg:top-24 lg:self-start">
        <Panel
          title="Result"
          testId="base64-output"
          action={output ? <CopyButton text={output} /> : null}
        >
          {error ? (
            <p data-testid="base64-error" className="min-h-[300px] font-mono text-sm text-destructive">
              {error}
            </p>
          ) : (
            <pre className="min-h-[300px] overflow-auto whitespace-pre-wrap break-all bg-background p-4 font-mono text-sm leading-relaxed">
              {output || <span className="text-muted-foreground">Result appears here…</span>}
            </pre>
          )}
        </Panel>
      </div>
    </div>
  );
}
